import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

const DeliveryPolicy = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <section>
            <div className="inn-body-section">
                <div className="container">
                    <div className="page-head">
                        <h2 style={{ 'fontSize': '33px' }}>Delivery Policy</h2>
                        <div className="head-title">
                            <div className="hl-1"></div>
                            <div className="hl-2"></div>
                            <div className="hl-3"></div>
                        </div>
                        <p>Secure Living. Peaceful Coexistence.</p>
                    </div>
                    <div className="content">
                        <div class="mb-5">
                            <strong>Security & Entry Policy</strong>
                            <ul>
                                <li>Residents must use the designated entrance, and the main gate will be closed after 10:00 PM.</li>
                                <li>Residents must obtain permission from the management if they need to enter after the stipulated time.</li>
                                <li>Residents are responsible for securing their valuables; the management will not be responsible for any loss or theft.</li>
                                <li>CCTV cameras will monitor the main entrance and other key areas for security purposes.</li>
                            </ul>
                        </div>

                        <div class="mb-5">
                            <strong>Rules & Discipline</strong>
                            <ul>
                                <li>Drugs, smoking, gambling, and any illegal substances are strictly prohibited.</li>
                                <li>Political activities and any form of religious or racial hate speech are strictly prohibited.</li>
                                <li>Any form of harassment toward another resident will result in immediate expulsion.</li>
                                <li>If a resident is involved in a serious offense, they must vacate the hostel within 2 hours.</li>
                                <li>All residents must ensure peaceful coexistence.</li>
                            </ul>
                        </div>

                        <div class="mb-5">
                            <strong>Legal & Ethical Policy</strong>
                            <ul>
                                <li>Any illegal activities, such as drug use, smoking, gambling, or criminal offenses, are strictly prohibited.</li>
                                <li>Political activities are not allowed inside the hostel.</li>
                                <li>If any resident harms another resident, legal action will be taken.</li>
                            </ul>
                        </div>

                        <div class="mb-5">
                            <strong>Emergency & Medical Policy</strong>
                            <ul>
                                <li>Emergency exit plans will be in place in case of natural disasters or fire.</li>
                                <li>If a resident falls seriously ill, the management will inform their family and assist in hospitalization, but the resident must bear the medical costs.</li>
                                <li>Basic first-aid facilities will be available for residents.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DeliveryPolicy;
